import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKalilinuxComponent } from './simple-icons-kalilinux.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKalilinuxComponent ],
    exports:      [ SimpleIconsKalilinuxComponent ],
    bootstrap:    []
})
export class SimpleIconsKalilinuxModule {}
